import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  buttonClose: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: 'rgba(215, 222, 233, 0.25)',
    '&:hover': {
      backgroundColor: 'rgba(215, 222, 233, 0.5)',
    },
  },
  iconClose: {
    width: '18px',
    height: '18px',
    color: '#4F4F4F',
  },
  warnIcon: {
    width: '48px',
    height: '46px',
    color: '#FF8946',
  },
  expiredIcon: {
    width: '48px',
    height: '46px',
    color: '#F64444',
  },
  licenseTimeText: {
    marginTop: '24px',
    color: '#101D40',
    fontFamily: 'Sora, sans-serif',
    fontSize: 22,
    fontWeight: 800,
    textAlign: 'center',
  },
  bodyText: {
    textAlign: 'center',
    marginTop: '13px',
    fontFamily: 'Sora, sans-serif',
    fontSize: 16,
    color: '#7C8DB5',
    '& > strong': {
      color: '#101D40',
    },
  },
  supportButton: {
    marginTop: '24px',
    width: '100%',
    height: '57px',
    borderRadius: '10px',
    backgroundColor: '#329BFC',
  },
  supportButtonText: {
    fontWeight: 500,
    color: '#FFF',
    fontFamily: 'Sora, sans-serif',
  },
  cancelButton: {
    marginTop: '16px',
    width: '100%',
    height: '57px',
    borderRadius: '10px',
    backgroundColor: '#E6EFFB',
  },
  cancelButtonText: {
    fontWeight: 500,
    color: '#25396F',
  },
}));
